const config = {
    title: 'Ooredoo TV+',
    client: 'ooredoo',
    clientName: 'Ooredoo 2024',
    authenticationTypeQr: '',
    defaultLocale: 'en',
    supportedLanguages: ['en', 'ar'],
    rtlLanguages: ['he', 'ar'],
    subscriptionUrl: '',
    isNewRelicDisabled: true,
    searchLeft: true,
    needRedemptionCodeFormat: false,
    redemptionCodeFormat: /^\w{4}-\w{4}-\w{4}-\w{4}$/gm,
    redemptionCodePlaceholder: "XXXX-XXXX-XXXX-XXXX",
    usernameLength: 8,
    recordingMessage: 'TV',
    epg: {
        numOfDaysFuture: 6,
        numOfDaysPast: 2,
        adjustTitlesInView: false
    },
    emiModules: {
        home: {
            isEMIUniverse: true,
            name: 'home',
        },
        vod: {
            isEMIUniverse: true,
            name: 'vod',
        },
        sport: {
            isEMIUniverse: true,
            name: 'sport',
        },
        kids: {
            isEMIUniverse: true,
            name: 'kids',
        },
        mytv: {
            isEMIUniverse: true,
            name: 'mytv',
        },
        theme: {
            isEMIUniverse: false,
            name: 'theme',
        },
        parameter: {
            isEMIUniverse: false,
            name: 'parameter'
        },
    },
    bootRequests: {
        lastChannelsLcn: {
            requestAtBoot: false,
            waitAtBoot: false,
        },
        recordings: {
            requestAtBoot: true,
            waitAtBoot: false,
        },
        recordingsFavorites: {
            requestAtBoot: false,
            waitAtBoot: false,
        },
        reminders: {
            requestAtBoot: true,
            waitAtBoot: false,
        },
        continueWatching: {
            requestAtBoot: true,
            waitAtBoot: true,
        },
        channelApps: {
            requestAtBoot: false,
            waitAtBoot: false,
        },
        products: {
            requestAtBoot: true,
            waitAtBoot: true,
        },
        liveNow: {
            requestAtBoot: false,
            waitAtBoot: false,
        },
        vodNodes: {
            requestAtBoot: false,
            waitAtBoot: false,
        },
        recommendation: {
            requestAtBoot: false,
            waitAtBoot: false,
        },
        vodFavorites: {
            requestAtBoot: true,
            waitAtBoot: false,
        },
        channels: {
            requestAtBoot: true,
            waitAtBoot: true,
        },
        mostWatched: { // Not implemented in volt api for ooredoo
            requestAtBoot: false,
            waitAtBoot: false,
        },
    },
    nagra: {
        tenantId: 'nagra',
        metadataProvider: 'GLOBAL',
        rollingBufferDuration: 24,
        fetchOnlySubscribedProducts: false,
    },
    forgotPasswordQr : '',
    forgotPassword: false,
    forgotParentalPinType: "message",
    audioLanguages: ['en', 'ar'],
    subtitleLanguages: ['off', 'en', 'ar'],
    defaultAudioLocale: 'en',
    defaultSubtitleLocale: 'en',
    purchaseAuthType: 'OTP',
    unsubscribeValidationMethod: 'PIN',
    showQRforSubscription: false,
    showDollerForRentSubscription: false,

    userAuthType: "LOGIN", //QR, LOGIN, BOTH
    allowLoginWithSecureId: false, // only for stb

    searchContentTypes: ['VOD', 'EPG_LIVE', 'EPG_PAST', 'EPG_FUTURE', 'CHANNEL'],
    localSearchContentTypes: ['VOD', 'EPG_LIVE', 'EPG_PAST', 'EPG_FUTURE', 'CHANNEL'],

    voltPlayer: {
        drmConfig: {
        },
        mediaEngine: 'shaka',
    },
    hasPortalScreen: true,
    emiModulesToUniverseRoot: {
        root: 'root',
        home: 'root-coach',
        vod: 'root-vod',
        sport: 'root-sport',
        kids: 'root-kids',
        mytv: 'root-mytv'
    },

    universeRootToEMIModule: {
        root: 'root',
        'root-coach': 'home',
        'root-vod': 'vod',
        'root-sport': 'sport',
        'root-kids': 'kids',
        'root-mytv': 'mytv'
    },
    enableGenresFilterNode: true,
    enableMultiLocalesMetadatas: true,
    contentNodePageSize: 3,
    emiScreenAliases: {
        "home": "root-coach",
        "vod":"root-vod",
        "live-tv": "root-epg",
        "sports": "root-sport",
        "subscriptions": "root-packages",
        'mytv': 'root-mytv',
    },
    screenPathAliases: {
        "root-coach": "home",
        "root-vod": "vod",
        "root-epg": "live-tv",
        "root-sport": "sports",
        "root-packages": "subscriptions",
        'root-mytv': 'mytv',
    },
    // TODO: to remove later, necessary for the moment to get a local kids profile
    dummyKidsProfile: {
        profileId: 'KIDS',
        username: 'KIDS',
        profileType: 'COMMON_PROFILE',
        pcLevel: 1,
        isKidProfile: true,
        namedProperties: {
            encryptedPassword: '94de8e73',
            isLocalProfile: true,
        },    
    },
    // show apps added in EMI requests
    showApps: true,

    // EMI provides layout/format info for items/rows
    supportedLayoutsFromEMi: ['vod', 'predefined', 'app'],

    // MAC-638 - default node ordering in descending order pending feature from EMI
    proxy: {
        defaultNodeOrdering: 'node_pos_desc',
        defaultCategoryOrdering: 'node_pos_desc', // Hack as feature not support by EMI and starhub very demanding
        enableFetchProductTitles: false,
    },
    customErrorMsg: {
        MAX_DEVICES_REACHED: {
            title: 'PBL-212-Max-Device-Reached',
            description:
                'Maximum permissible device count for your account reached. Please, manage device count from your other device ( like STB)',
            subDescription: '',
        },
    },
    epgGrid: {
        flatEpg: false, // flat or classic grid
        epgFlatDefaultSlotDurationMin: 30, // half hour
        epgVisibleSlots: 5, // N slots visible in EPG
        epgVisibleLineCount: 7, // number of visible line in flat EPG
        epgMaxConcurrentRequests: 3,
        epgPrefetchBatchSize: 20, // The number of prefetched channels in the EPG (current day only)
        epgHorizontalDurationHours: 4,
        epgPlaceHolderDuration: 2, // in hours
    },
    epgChannelsBatchSize: 15,
    menuTranslationFromLocal: false,

    //Display content title or Watch button flag
    heroSliderTitleDisplay: true,
    MAX_DEVICES_REACHED: {
        title: 'PBL-212-Max-Device-Reached',
        description:
            'Maximum permissible device count for your account reached. Please, manage device count from your other device ( like STB)',
        subDescription: '',
    },

    // if purchase can be done with this currency - then wallet should be displayed
    walletCurrency: 'Credit',
    
    // Dynamic Content FIREBASE_COMMON_CONFIG
    analytics: {
        // This configuration allowyou to disable Analytics
        disabled: false,
        // This value force to get user consent beforce enabling Analytics.
        // Not required for all country (Example: Required in US/Europe, not really in Asia)
        // UI to be implemented for getting user consent
        userConsentRequired: false,
        // For device sampling, percentage of devices allowed for analytics
        percentageEnabled: 100,
        // Force User Personnal data collection even if user did not provide his consent
        forcePersonalUserDataCollection: true,
        // Session of analytics. By default 30 minutes before closing a session
        // sessionDurationMs: 30 * 60 * 1000,
        // Define the list of supported event (Native and Custom)
        supportedEvents: [
            // -- Events enabled by default --
            'screen',
            'login',
            'sign_up',
            'app_open',
            'starter_kit',
            'content_click',
            'purchase',
            'search',
            // --- Custom Events ---
            'bootstrap_data',
            'logout',
            'unsubscribe',
            'activate_subscription',
            'playback_start',
            'playback_pause',
            'playback_resume',
            'playback_stop',
            'playback_error',
            'emi',
            // Additionnal errors from the UI
            'app_error',
            'favorites_add_content',
            'favorites_remove_content',
            'add_reminder',
            'remove_reminder',
            'setting_update_parental_control',
            'setting_update_pin',
            'setting_reset_pin',
            'setting_update_password',
            'record_dvr_program',
            'record_dvr_serie',
            'cancel_dvr',
            'delete_dvr',
            'modify_dvr',
            'delete_device',
            'modify_device',
            'add_profile',
            'delete_profile',
            'switch_profile',
            'launcher_app_installed',
            'launcher_app_removed',
        ],
        firebaseScreen: {
            SEARCH: 'SEARCH',
            EPG: 'EPG',
            WALL: 'WALL_VIEW',
            PLAYBACK: 'PLAYBACK_FULLSCREEN',
            SETTINGS: 'SETTINGS',
            DETAILS: 'DETAIL_VIEW',
            HOME: 'HOME',
            VOD: 'VOD',
            SPORTS: 'SPORT',
            APPS: 'APPS',
            MYTV: 'MYTV',
            DVR: 'DVR',
            PACKAGES: 'SUBSCRIPTIONS',
            BACKGROUND: 'BACKGROUND',
            MENU: 'MENU',
            BOOTSTRAP: 'BOOT_SCREEN',
        },
    },
    theme: {
        focusColor: "#ebebebff",
        focusTextColor: "#171a30ff",
        textColor: "#ebebebff",
        backgroundColor: "#171a30ff",
        secondaryBackgroundColor: "#222439ff",
        backgroundBlurColor: "#ebebeb0d",
        interactiveBackgroundColor: "#ebebeb1a",
        primaryBackgroundColor: '#171a30ff',
        fontFamily: 'Rubik',
        kidsIconFocusColor:'#E52B50',
        kidsIconFocusTextColor:'#EEEEEE'
    },
    navigationMenuIgnoreList: ['root-recordings', 'root-packages', 'root-offer', 'root-replay'],
    guestModeMenuIgnoreList: ['root-recordings', 'root-packages', 'root-offer', 'root-replay'],
    pcLevels: {
        QT_G: 0, // 1,
        QT_PG: 12, // 13,
        QT_PG13: 12, // 13,
        QT_PG15: 14, // 15,
        QT_R: 16, // 17,
        QT_NR: 49, // 50,
        UNRATED: 49, // Security
    },

    maxPcLevelKid: 7,

    // Special rating level for which censorship pin is needed rather than adult pin
    censoredLevel: 20,

    bootLogo: true,

    agama: {
        // Agama analytics status
        enable: true,
        //Console URI
        _configuration:"emp_service=https://aggregation.castling.uk/report;report_interval=240;id_report_interval=4800;operator_id=Ooredoo_0x5E01_VLTN;",
         // player name
        playerName: 'Shaka Player',
        playerVersion: '4.3.8-nmp-2',
        caSystem: 'PlayReady',
        cdn: 'Huawei',
        //DEBUG for development and INFO for deployment.
        verbose:'Agama.LogLevel.FATAL'
    },

    // userPcLevels and content pcLevels (see above) are not the same.
    // You'll find below a map associating each userPcLevel with a label.
    // Not in volt-trad as it's very client specific
    userPcLevels: [
        {
            backendRatingId: '5',
            title: { en: 'All', ar: 'الجميع' },
            description: {
                en:
                    'All Content Available.',
                ar:
                    'كل المحتوى متاح.'
            },
            level: 50,
        },
        {
            backendRatingId: '0',
            title: { en: 'G', ar: 'G' },
            description: {
                en:
                    'Nothing that would offend parents for viewing by children.',
                ar:
                    'لا شيء من شأنه أن يسيء إلى الآباء لمشاهدتها من قبل الأطفال.'
            },
            level: 1,
        },
        {
            backendRatingId: '1',
            title: { en: 'PG', ar: 'PG'  },
            description: {
                en: 'Parents urged to give "parental guidance"',
                ar: 'حث الآباء على تقديم "إرشادات الوالدين"'
            },
            level: 7,
        },
        {
            backendRatingId: '2',
            title: { en: 'PG-13', ar: 'PG-13'  },
            description: {
                en: 'Some material may be inappropriate for children under 13',
                ar: 'قد تكون بعض المواد غير مناسبة للأطفال دون سن 13 عاما'
            },
            level: 13,
        },
        {
            backendRatingId: '3',
            title: { en: 'PG-15', ar: 'PG-15'  },
            description: {
                en:
                    'Some material may be inappropriate for children under 15',
                ar:
                    'قد تكون بعض المواد غير مناسبة للأطفال دون سن 15 عاما'
            },
            level: 15,
        },
        {
            backendRatingId: '4',
            title: { en: 'R', ar: 'R'  },
            description: {
                en:
                    'Under 17 requires accompanying parent or adult guardian',
                ar:
                    'يتطلب الأطفال دون سن 17 عاما مرافقة أحد الوالدين أو وصي بالغ'
            },
            level: 17,
        }
    ],
    settings: [{
        title: "SETTINGS",
        haveChildren: true,
        disabled: false,
        id: 'mainSettings',
        childrens: [
            {
                title: "SETTINGS_TITLE",
                id: "tvAppSettings",
                detailTitle:'',
                haveChildren: true,
                disabled: false,
                childrens: [
                    {
                        title: "OVERSCAN",
                        disabled: true,
                        id: "overscan",
                        haveChildren: false
                    },
                    {
                        title: "TRANSACTION_HISTORY",
                        disabled: true,
                        id: "transactionlist",
                        haveChildren: false
                    },
                    {
                        title: "AUDIO_SUBTITLE",
                        disabled: true,
                        id: "audiosubtitle",
                        haveChildren: false
                    },
                    {
                        title: "MENU_LANGUAGE",
                        disabled: false,
                        id: "menulanguage",
                        haveChildren: false
                    },
                    {
                        title: "DEFAULT_AUDIO_LANGUAGE_TITLE",
                        disabled: false,
                        id: "audiotitleLanguage",
                        haveChildren: false
                    },
                    {
                        title: "DEFAULT_SUBTITLE_LANGUAGE_TITLE",
                        disabled: false,
                        id: "subtitleLanguage",
                        haveChildren: false
                    },
                    {
                        title: "DEVICE_MANAGEMENT",
                        disabled: false,
                        id: "deviceManagement",
                        haveChildren: false
                    },
                    {
                        title: "POWER_MANAGEMENT",
                        disabled: true,
                        id: "powerManagement",
                        haveChildren: false
                    },
                    {
                        title: "TERMS_N_CONDITIONS",
                        disabled: false,
                        id: "termsconditions",
                        haveChildren: false
                    },
                    {
                        title: "HELP_AND_FAQ",
                        disabled: false,
                        id: "helpfaqs",
                        haveChildren: false
                    },
                    {
                        title: "LOG_OUT",
                        disabled: false,
                        id: "logOut",
                        haveChildren: false
                    },
                    {
                        title: "EXIT_APP",
                        disabled: false,
                        id: "exitapp",
                        haveChildren: false
                    }
                ]
            },
            {
                title: "PROFILE_SETTINGS",
                id: "PROFILE_SETTINGS",
                detailTitle: "DETAIL_SETTINGS_TITLE",
                haveChildren: true,
                disabled: false,
                childrens: [
                    {
                        title: "ACCOUNT",
                        disabled: true,
                        id: "accountInfo",
                        haveChildren: false
                    },
                    {
                        title: "PROFILE_NAME",
                        disabled: false,
                        id: "profileName"
                    },
                    {
                        title: "AVATAR",
                        disabled : false,
                        id: "avatar"
                    },
                    {
                        title: "PARENTAL_LEVEL",
                        disabled: false,
                        id: "parentalLevel"
                    },
                    {
                        title: "PARENTAL_CODE",
                        disabled: false,
                        id: "parentalCode"
                    },
                    {
                        title: "R21_PIN",
                        disabled: true,
                        id: "r21code"
                    },
                    {
                        title: "RESTRICT_BY_CHANNEL",
                        disabled: false,
                        id: "restrictedByChannel"
                    },
                    {
                        title: "REDEMPTION_CODE",
                        disabled: true,
                        id: "redemptionCode"
                    },
                    {
                        title: "CHANNEL_FILTERING",
                        disabled: false,
                        id: "channelFiltering",
                        haveChildren: false
                    },{
                        title: "DELETE_PROFILE",
                        disabled: false,
                        id: "deleteProfile",
                        haveChildren: false
                    }
                ]
            },
            {
                title: 'MY_ACCOUNT_DETAILS',
                id: "myAccountDetails",
                detailTitle:"",
                haveChildren: false,
                disabled: false,
            },
            {
                title: "ENVIRONMENT",
                disabled: false,
                detailTitle:"",
                id: "enviroment",
                haveChildren: true,
                childrens: [
                    {
                        title: "PRODUCTION",
                        disabled: false,
                        id: "production"
                    },
                    {
                        title: "PREPRODUCTION",
                        disabled: false,
                        id: "preproduction"
                    },
                    {
                        title: "INTERNALPROD",
                        disabled: false,
                        id: "internalproduction"
                    },
                    {
                        title: "STAGING",
                        disabled: false,
                        id: "staging"
                    },
                    {
                        title: "QA",
                        disabled: false,
                        id: "qa"
                    },
                    {
                        title: "DEVELOPEMENT",
                        disabled: false,
                        id: "development"
                    }
                ]
            },
            {
                title: { en: "System Settings", ar: 'إعدادات النظام' },
                id: "systemSettings",
                haveChildren: true,
                disabled: true,
                childrens: [
                    //Add as give for TV App Settings
                ]
            }
        ]
    }
    ],
    disable_R21_option: false,
    posterRatio: '2/3',
    landscapeRatio: '16/9',
    showAccountTab: false,
    manageSubscription : false,
    userPcLevelSort: false,
    emailID : "HUB ID:",
    customerId : "TVID:",
    heroSliderAutoplayDuration : 5000,
    showBingeWatch : false,
    purchasePanelLegacyUI : true,
    showExitPopup: true,
    subscriptionLink: '',
    favoriteChannelFilterKey: 'channelNumber', 
    pageLimit: {
        // pagination limit for getChannels service
        liveNow: 100,
        // pagination limit for getEventRecordings service
        recordings: 1000,
        // pagination limit for getProgressiveLiveNow service
        channels: 500,
        // pagination limit for getOrderedChannelsData store method
        epgData: 500
    },
    youtube: {
        apiKey: 'AIzaSyAKhlUYodqq-oWJVmkV32X2DlxPHv2yj7s',
        regionCode: 'QA',
        maxPageAllowed: 3,
        usePlaylistFirstItem: false, // Due to youtube feedback, avoid to display Playlist tile
    },
    isRestrictedContent: {
        blurHeroBanner:false,
        showParentalRating:false,
    },
    accountDetails: {
        displayRestartButton: false,
        hiddenFields: ['accountId', 'connectionQuality', 'businessType'],
    },
    // This configuration is to filter out packages that are subscribed on item by item curated swimlane composed only by packages
    emiFilterOutSubscribedPacksFromFullPacksSwimlane: true,
    // This configuration is to decide on rewind press of live feedback if need to change stream if not having timeshif available (till now for ooredoo only)
    useTimeShiftedLive: true,
    jumpLocalKeys:['98f1216da0b24011a0ecc3f334e637e1','b3c77690182a4f53b7f82e9c81539827','060cb45f6ddf4329a76dbc039f52ad15','81af49ad75994ebd8daa391b9b471d2f','5b4e6b9c8a50429597ae8f1f17122e1a','4d938fb0226d48d78cefde15bad2c6a3','fe85981d6a2d46d8bc1c1a31244bf421'],
    // Configuration for multiple profiles
    profiles: {
        multiprofiles: false,
        defaultAvatar: 'PP_15',
        maxProfilesCount: 5,
        showManageProfile: false
    },
    channelFiltersPerProfile: false,
    askParentalOnResume: false,
    displaySeriesRecommendation: false,
    displayMovieRecommendation: false,
    defaultDynamicSwimlaneLength: 10,
    recommendationValidityPeriod: 60 * 60 * 1000, // Validity period for a recommendation in milliseconds (2 minutes)
    getAllJumpConfig: {
        recoUrl: 'https://ooredoo-api-pqqsp5puja-ew.a.run.app',
        jwt: {
            issuer: 'web1.oredoo.com',
            subject: '3ffd1bb5-9528-43be-bb67-e625bfba3dbf',
            audience: 'https://ooredoo-api-pqqsp5puja-ew.a.run.app',
            jti: '9e854fd2-a84c-4754-acc8-fdfcff05ed61',
            secretKey: 'dZh34FptCLriqY7eB2X1OA89WNK0QMc5jTLGfuvbEsSoPnaZywx',
            roles: ['admin'],
            headers: { alg: 'HS256', typ: 'JWT' },
        },
    },
}

export default config
